module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-tabbar', {
    attrs: {
      "fixed": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    staticClass: "tab-item",
    attrs: {
      "id": "首页"
    },
    nativeOn: {
      "click": function($event) {
        _vm.changePage('/home', '首页')
      }
    }
  }, [(_vm.selected === '首页') ? _c('img', {
    staticClass: "tab-item-img",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/icon/tabbar_home_selected.png")
    },
    slot: "icon"
  }) : _c('img', {
    staticClass: "tab-item-img",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/icon/tabbar_home.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-item-title"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tab-item",
    attrs: {
      "id": "购物车"
    },
    nativeOn: {
      "click": function($event) {
        _vm.changePage('/ShoppingCart', '购物车')
      }
    }
  }, [(_vm.selected === '购物车') ? _c('img', {
    staticClass: "tab-item-img",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/icon/TabBar_Cart_selected.png")
    },
    slot: "icon"
  }) : _c('img', {
    staticClass: "tab-item-img",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/icon/TabBar_Cart.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-item-title"
  }, [_vm._v("购物车")])]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tab-item",
    attrs: {
      "id": "我的"
    },
    nativeOn: {
      "click": function($event) {
        _vm.changePage('/Mine', '我的')
      }
    }
  }, [(_vm.selected === '我的') ? _c('img', {
    staticClass: "tab-item-img",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/icon/TabBar_My_selected.png")
    },
    slot: "icon"
  }) : _c('img', {
    staticClass: "tab-item-img",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/icon/TabBar_My.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-item-title"
  }, [_vm._v("我的")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-562343a9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/mainNavBar.vue
// module id = 571
// module chunks = 1